import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'

import ActionItem from './ActionItem'
import { useParams } from 'react-router-dom'
import { DraftContext } from '../../../../../../contexts/DraftContext'

export default observer(function ActionsByPlatform({ platform }) {
  const { actionsForInfluencer } = useContext(DraftContext)
  const {influencer_id} = useParams()

  const infActions = actionsForInfluencer(influencer_id).filter(action => action.provider === platform)
  return (
    <div>
      <div>
        <div className='p-2'>
          { infActions.map(action => <ActionItem key={action.id} action={action} />) }
        </div>
      </div>
    </div>
  )
})
